module.exports = __webpack_public_path__ + "static/media/Olamide Ilori.0fd9b994.png";